import { AccountTopNavigation } from '~/@biz_account/top-navigation/AccountTopNavigation'

function Container(props: { children: React.ReactNode | React.ReactNode[] }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      {props.children}
    </div>
  )
}

function ContainerContent(props: { children: React.ReactNode }) {
  return (
    <div className="flex items-start col-span-1">
      <div className="flex flex-col justify-center items-center gap-0 w-full">
        <AccountTopNavigation showAllItems={false} colorScheme="light" />
        <div className="flex flex-col gap-10 w-full lg:max-w-[640px] px-5 py-[60px] lg:py-auto pb-10 lg:pb-20">
          {props.children}
        </div>
      </div>
    </div>
  )
}

function ContainerSideMenu(props: { children: React.ReactNode }) {
  return (
    <div className="hidden lg:flex lg:col-span-1 justify-center items-center bg-foreground text-primary-foreground">
      {props.children}
    </div>
  )
}

export { Container, ContainerContent, ContainerSideMenu }
